module.exports = __webpack_public_path__ + "static/media/brand-icons.a046592b.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/brand-icons.woff
// module id = 4413
// module chunks = 0